import vuex from '../store/index.js'
export var senserData = function(number, data_class) {
  let unit = null,
    data = null,
    name = null;
  function handlers(number, data_class) {
    if (number === null) return '--'
    let data = number;
    if (data_class == 'sleet') {
      data = ["无降水", "有降水"][number]
    } else if (data_class == 'wind_direction') {
      if (number >= 22.5 && number < 67.5) {
        data = "东北";
      } else if (number >= 67.5 && number < 112.5) {
        data = "东";
      } else if (number >= 112.5 && number < 157.5) {
        data = "东南";
      } else if (number >= 157.5 && number < 202.5) {
        data = "南";
      } else if (number >= 202.5 && number < 247.5) {
        data = "西南";
      } else if (number >= 247.5 && number < 292.5) {
        data = "西";
      } else if (number >= 292.5 && number < 337.5) {
        data = "西北";
      } else {
        data = "北";
      }
    } else {
      if (number > 1000) {
        data = (number / 1000).toFixed(2) + 'k'
      } else {
        data = number
      }
    }
    return data
  }
  vuex.state.deviceClass.filter(item => {
    if (item.device_data_name == data_class) {
      unit = item.unit;
      name = item.device_class_name;
      data = handlers(number, data_class)
      return true
    } else {
      return false
    }
  })
  if(name.includes('传感器')){
    name = name.split('传感器')[0]
  }
  return {
    unit,
    data,
    name
  }
}
